import { default as planModule } from './module/store' 
import { default as planType } from './type/store'	
import { default as planChargeType } from './charge-type/store'
import { default as plan } from './plan/store'
import { default as additionalService } from './additional-service/store'
import { default as installment } from './installment/store'

export default { 
	planModule,
	planType,
	planChargeType,
	installment,
	additionalService,
	plan
}
